// Auto-generated resource for PromptsOffline — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const PromptsOfflineKeys = {
  Riff: 'PromptsOffline.Riff',
  ReadAloud: 'PromptsOffline.ReadAloud',
  ArchetypeClause: 'PromptsOffline.ArchetypeClause',
  Continue: 'PromptsOffline.Continue',
  StoryRequest: 'PromptsOffline.StoryRequest',
  CustomStoryRequest: 'PromptsOffline.CustomStoryRequest',
  TopicInstrument: 'PromptsOffline.TopicInstrument',
  TopicBodyLanguage: 'PromptsOffline.TopicBodyLanguage',
  TopicArchetype: 'PromptsOffline.TopicArchetype',
  RiffRequest: 'PromptsOffline.RiffRequest',
  RiffCategory: 'PromptsOffline.RiffCategory',
  RiffTheme: 'PromptsOffline.RiffTheme',
} as const;

export const PromptsOfflineValues = {
  'default': {
    'ArchetypeClause': 'Give the story a few clear emotional turns so the reader can shift tone naturally.',
    'Continue': 'Continue the same story from where it stopped, for about {missingWords} more words. Keep the same characters, voice and style, and pick up with the very next sentence. Reply with the new paragraphs only.',
    'CustomStoryRequest': 'Write a story of {targetWords} words about this topic: {topic}.',
    'ReadAloud': 'Write the story as plain prose, in a few paragraphs of full sentences. {archetypeClause}Reply with the story only: no title, no preamble, no markdown.',
    'Riff': 'You generate material for a voice practice called Riff. Output PLAIN TEXT only — no JSON, no markdown, no numbering, no preamble, no labels.\nWrite the WORD first, then the help sentences, like this:\n  {exampleWord}. Recall a place that felt like a refuge. Say what it reminds you of. Name a sound you hear there.\nRules:\n- The very first item is ONE single English word — a lowercase noun, verb, or adjective — of the kind the user message asks for. Make it a word any adult knows and can talk about at once, never rare or obscure, and never a term from these instructions.\n- Every following item is a short sentence (5-15 words) that nudges a stalled speaker.\n- EVERY item — the word and each sentence — ends with a single period ".". Use NO other periods anywhere (no abbreviations, no ellipses, no decimals).\n- Return exactly N help sentences where N is given in the user message.',
    'RiffCategory': 'Make it {category}.',
    'RiffRequest': 'Pick one fresh, random English word — a noun, verb, or adjective — and NOT "help" or "word". {wordClause}Then write {cueCount} short sentences that nudge a stalled speaker. Put the word first, then the {cueCount} sentences, each ending with a single period.',
    'RiffTheme': 'Draw the word from this theme: {topic}.',
    'StoryRequest': 'Write a story of {targetWords} words about {topic}.',
    'TopicArchetype': 'someone changing their mind',
    'TopicBodyLanguage': 'a moment of strong emotion',
    'TopicInstrument': 'a random everyday moment',
  },
} as const;

